module.exports = __webpack_public_path__ + "static/media/illustration_footer.07208e1d.svg";